import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Row, Button, FormCheck, FormControl, InputGroup } from "react-bootstrap";
import { Formik } from 'formik';

import { faDollarSign } from '@fortawesome/pro-solid-svg-icons/faDollarSign';
import FontAwesome from 'utils/FA';

import { feeRules } from '../../ducks';
import { duckify } from "utils/duckify";

import ModalComponent from '../ModalComponent';
import FeeGroupModalErrorWrapper from './FeeGroupModalErrorWrapper';

const FeeGroupFeeModal = ({ closeModal, feeGroupId, feeRulesCreate, feeRulesUpdate, editData }) => {

  const [formikErrors, setFormikErrors] = useState({});

  const initialValues = {
    active : false,
    amount : '',
    description : '',
    fee_id : feeGroupId,
    name : '',
    test : ''
  };

  if (editData){
    initialValues.active = editData.active;
    initialValues.amount = editData.amount;
    initialValues.description = editData.description;
    initialValues.name = editData.name;
    initialValues.test = editData.test;
  }

  const onSubmit = (values) => {

    if (editData){
      values.id = editData.id;
    }

    const dispatchFeeRule = editData ? feeRulesUpdate(values) : feeRulesCreate(values);

    dispatchFeeRule
      .then(()=> {
        closeModal();
      })
      .catch((err) => {
        setFormikErrors(err);
      })
  };

  return (
    <Formik
      initialValues={ initialValues }
      onSubmit={ (values) => onSubmit(values) }
    >
      {({
        values,
        handleChange,
        handleSubmit
      }) => {

        const buttons = [
          <Button type="submit" onClick={handleSubmit}>Confirm</Button>
        ]

        return (
          <ModalComponent
            onClose={() => closeModal()}
            className={'fee-group-modal fee-group-fee-modal'}
            title={'Fee Details'}
            buttons={buttons}
          >
            <form>
              {Object.keys(formikErrors).length > 0 &&
                <FeeGroupModalErrorWrapper>
                  {formikErrors.name && <li><span className="feegroup-error-wrapper-title">Name</span> {formikErrors.name}</li>}
                  {formikErrors.amount && <li><span className="feegroup-error-wrapper-title">Amount</span> {formikErrors.amount}</li>}
                  {formikErrors.test && <li><span className="feegroup-error-wrapper-title">Condition</span> {formikErrors.test}</li>}
                </FeeGroupModalErrorWrapper>
              }

              <Row className={formikErrors.name ? 'error' : null}>
                <label className="control-label">Fee Name</label>
                <div className="controls">
                  <FormControl type={'text'} name={'name'} defaultValue={values.name} onChange={handleChange} />
                  <span className="helper-text"> Displays on forms</span>
                </div>
              </Row>

              <Row>
                <label className="control-label">Description</label>
                <div className="controls">
                  <FormControl type={'text'} name={'description'} defaultValue={values.description} onChange={handleChange} />
                  <span className="helper-text"> Internal only</span>
                </div>
              </Row>

              <Row className={formikErrors.amount ? 'error' : null}>
                <label className="control-label">Amount</label>
                <div className="controls">
                  <InputGroup>
                    <InputGroup.Text><FontAwesome icon={faDollarSign} /></InputGroup.Text>
                    <FormControl type={'text'} name={'amount'} defaultValue={values.amount} onChange={handleChange} />
                  </InputGroup>
                </div>
              </Row>

              <Row className={formikErrors.test ? 'error' : null}>
                <label className="control-label">Conditions</label>
                <div className="controls">
                  <textarea type={'textarea'} name={'test'} value={values.test} onChange={handleChange} />
                </div>
              </Row>

              <Row>
                <label>Active</label>
                <div className="controls">
                  <FormCheck type={'checkbox'} name={'active'} defaultChecked={values.active} onChange={handleChange} />
                </div>
              </Row>


            </form>
          </ModalComponent>

        )

      }}

    </Formik>
  )

};

const mapDucksToProps = () => ({});
const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  feeRulesCreate: (feeRulesObj) => {
    return dispatch(feeRules.actions.create(feeRulesObj)).then(() => dispatch(feeRules.actions.markDirty()))
  },
  feeRulesUpdate: (feeRulesObj) => {
    return dispatch(feeRules.actions.update(feeRulesObj))
  }
});

FeeGroupFeeModal.propTypes = {
  feeGroupId: PropTypes.string,
  feeRulesCreate: PropTypes.func,
  feeRulesUpdate: PropTypes.func,
  closeModal: PropTypes.func,
  editData: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    amount: PropTypes.string,
    test: PropTypes.string,
    active: PropTypes.bool
  })
};

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(FeeGroupFeeModal);
